import { render, staticRenderFns } from "./NormalizedBarChartWidget.vue?vue&type=template&id=c55628ee&scoped=true"
import script from "./NormalizedBarChartWidget.vue?vue&type=script&lang=js"
export * from "./NormalizedBarChartWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55628ee",
  null
  
)

export default component.exports